import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/sticker.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/about/about.module.css");
